import { POSITION } from "@voltmoney/types";
import { api, config } from "../../../configs/api";
import { APP_CONFIG, getAppHeader } from "../../../configs/config";
import { ROUTE } from "../../../routes";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputStateToken, InputTypeToken, KeyboardTypeToken, SizeTypeTokens, StackAlignContent, StackAlignItems, StackHeight, StackJustifyContent, StackSelfContent, StackType, StackWidth, TextInputTypeToken, WIDGET } from "@voltmoney/schema";
import { ACTION } from "./types";
import { RAZOR_PAY_PREFERRED_METHOD, addCommasToNumber, getRazorpayKey, getUserContext, handlePayment, handleWebPayment, isFromAndroidWebview, isFromTDLPlatform } from "../../../configs/utils";
import { Platform, Linking, AppState } from "react-native";
import { LENDER_ID, REPAYMENT_COLLECTION_TYPE } from "../../../configs/constants";
import { importBillDeskSdk } from "./utils";
import SharedPropsService, { BUILD_TYPE, getBuildType } from "../../../SharedPropsService";
import { InAppBrowser } from 'react-native-inappbrowser-reborn';
import BackgroundTimer from 'react-native-background-timer';
//@ts-ignore
import ThemeProvider from "@voltmoney/theme";
import { PaymentStatuses } from "../paymentCallback/types";
import { getParameters } from "../../../configs/uri-config-utils";
const sleep = (time) => new Promise((resolve) => setTimeout(() => resolve(), time));
const theme = ThemeProvider.getTheme();
const colorMapping = theme.colors;
let pollarTimer;
let amount;
let isIframeRemoved = false;
let result;
let paymentFailed = false;
let collectionType = '';
let fromRetryPayment = false;
let preFilledAmount;
let timer;
const openLink = async (url, setDatastore) => {
    try {
        if (await InAppBrowser.isAvailable()) {
            let result = await InAppBrowser.open(url, {
                // iOS Properties
                dismissButtonStyle: 'cancel',
                preferredBarTintColor: '#453AA4',
                preferredControlTintColor: 'white',
                readerMode: false,
                animated: true,
                modalPresentationStyle: 'fullScreen',
                modalTransitionStyle: 'coverVertical',
                modalEnabled: true,
                enableBarCollapsing: false,
                // Android Properties
                showInRecents: true,
                showTitle: true,
                toolbarColor: '#1434CB',
                secondaryToolbarColor: 'black',
                navigationBarColor: 'black',
                navigationBarDividerColor: 'white',
                enableUrlBarHiding: true,
                enableDefaultShare: true,
                forceCloseOnRedirection: false,
                // Specify full animation resource identifier(package:anim/name)
                // or only resource name(in case of animation bundled with app).
                animations: {
                    startEnter: 'slide_in_right',
                    startExit: 'slide_out_left',
                    endEnter: 'slide_in_left',
                    endExit: 'slide_out_right'
                },
                headers: {
                    'my-custom-header': 'my custom header value'
                }
            });
            if (result.type === "cancel") {
                await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                    loading: false
                });
                BackgroundTimer.stopBackgroundTimer(); //after this call all code on background stop run.
            }
        }
        else
            Linking.openURL(url);
    }
    catch (error) {
    }
};
let prevAppState = AppState.currentState;
export const closeLoader = async (action, _datastore, { navigate, setDatastore, removeWidgets }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const leadToPayment = async (action, _datastore, { network, appendWidgets, openNewTab, removeWidgets, showPopup, setDatastore, goBack, navigate, getHeight, instrumentTrack, navigateWithClear, navigateToBase }) => {
    await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
        loading: true
    });
    const paymentMode = action?.payload?.value;
    const userContextResponse = await network.post(api.userContext, {}, { headers: await getAppHeader() });
    const userCreditId = userContextResponse.data.linkedCredits[0].creditId;
    const initialAmount = parseFloat(userContextResponse.data.linkedCredits[0].principalOutStandingAmount);
    const lenderAccountId = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId;
    var popupWindow;
    let tataFlag = false;
    if (lenderAccountId.toLowerCase() === LENDER_ID.TATA.toLowerCase()) {
        const accountId = userContextResponse?.data.linkedApplications[0].accountId;
        const response = await network.get(`${api.isTataMergerEnabled}${accountId}`, { headers: await getAppHeader() });
        tataFlag = response?.data?.isEnabled;
    }
    //billDeskIntegration
    if (lenderAccountId.toLowerCase() === LENDER_ID.MIRAE.toLowerCase()) {
        await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
            loading: true
        });
        if (amount <= initialAmount) {
            console.warn('*** leadToPayment action added ****');
            await network.post(`${api.collectionNew}`, {
                baseOriginUrl: `${config.APP_URL}`,
                collectionAmount: `${amount}`,
                creditId: userCreditId,
                redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false
            }, { headers: await getAppHeader() })
                .then(async (res) => {
                if (res.status === 200) {
                    const pgResponseDetails = res?.data?.pgResponseDetails;
                    const flow_config = {
                        merchantId: "BDUATV2K07",
                        bdOrderId: pgResponseDetails.pgTrackingId,
                        authToken: `OToken ${pgResponseDetails.authorizationToken}`,
                        childWindow: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? false : true,
                        retryCount: 3,
                        prefs: { "payment_categories": ["card", "nb"] }
                    };
                    if (Platform.OS !== 'web') {
                        removeWidgets(ROUTE.PAYMENT_START, [
                            {
                                id: "totalAmountShowStack",
                                type: WIDGET.CARD,
                                padding: {
                                    horizontal: 0,
                                    all: 0,
                                },
                                position: POSITION.ABSOLUTE_TOP,
                            },
                            {
                                id: "titleStack",
                                type: WIDGET.STACK,
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "fullAmountStackWithSpace",
                                type: WIDGET.STACK
                            },
                            {
                                id: "spaceXXXL",
                                type: WIDGET.SPACE
                            },
                            {
                                id: "divider",
                                type: WIDGET.DIVIDER
                            },
                            {
                                id: "partialAmountFullStack",
                                type: WIDGET.STACK
                            },
                            {
                                id: "proceedButtonStack",
                                type: WIDGET.STACK,
                                position: POSITION.ABSOLUTE_BOTTOM
                            },
                            {
                                id: "spaceLG",
                                type: WIDGET.SPACE
                            },
                            { id: "enterAmountFullStack", type: WIDGET.STACK },
                            { id: "amountMessage", type: WIDGET.TEXT }
                        ]);
                        await appendWidgets(ROUTE.PAYMENT_START, {
                            repayLoanWebView: {
                                iframe: false,
                                uri: res.data.paymentLink,
                                authToken: `OToken ${pgResponseDetails.authorizationToken}`,
                                pgTrackingId: pgResponseDetails.pgTrackingId,
                                height: getHeight(),
                                showBillDesk: true,
                                mfHeight: getHeight() - 150,
                                billDeskCancelAction: {
                                    type: ACTION.RESET_PAGE,
                                    routeId: ROUTE.PAYMENT_START
                                }
                            },
                            keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                            keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                        }, [
                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                            { id: "keyboardSpace", type: WIDGET.SPACE },
                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                        ], "customHeader");
                        const runPollar = async () => {
                            network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                if (response.data.collectionStatus !== 'REQUESTED') {
                                    clearInterval(timer);
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ]);
                                    // navigates to the payment callback page when the transaction has given a callback
                                    navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                }
                            });
                        };
                        timer = setInterval(() => {
                            runPollar();
                        }, APP_CONFIG.POLLING_INTERVAL);
                        return;
                    }
                    else {
                        const responseHandler = async (txn) => {
                            if (txn && isIframe()) {
                                if (txn.status === 200) {
                                    const collectionId = txn?.txnResponse?.orderid;
                                    network.get(`${api.userPaymentData}${collectionId}`, { headers: await getAppHeader() }, async () => {
                                        return;
                                    }, {
                                        disableDefault: true
                                    }).then((response) => {
                                        if (response.data.collectionStatus !== 'REQUESTED') {
                                            navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                        }
                                    });
                                }
                            }
                            await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                                loading: false
                            });
                        };
                        const config = {
                            responseHandler: responseHandler,
                            merchantLogo: "",
                            flowConfig: flow_config,
                            flowType: "payments"
                        };
                        if (Platform.OS === 'web') {
                            setTimeout(() => {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                //@ts-ignore
                                window.loadBillDeskSdk(config);
                            }, 1000);
                        }
                    }
                }
            });
        }
    }
    else {
        //Tata and Other Payment Integration
        if (amount <= initialAmount) {
            await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                loading: true
            });
            if (lenderAccountId === "Nuvama") {
                await navigate(ROUTE.PAYMENT_OPTIONS, {
                    amountSelected: `${amount}`
                });
            }
            else if (lenderAccountId?.toLowerCase() === LENDER_ID.DSP.toLowerCase()) {
                const response = await network.post(`${api.collectionNew}`, {
                    baseOriginUrl: `${config.APP_URL}`,
                    paymentGatewayIntegrationType: 'PG_SDK',
                    collectionAmount: `${amount}`,
                    creditId: userCreditId,
                    redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
                    paymentMode: paymentMode,
                    collectionType: collectionType !== '' && collectionType !== undefined ? collectionType : `${REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT}`
                }, { headers: await getAppHeader() });
                if (response?.status === 200) {
                    const timeout = 600;
                    const collectionId = response?.data?.collectionId;
                    const currentOrderId = response?.data?.pgPaymentOrderId;
                    const key = getRazorpayKey();
                    const user = userContextResponse?.data;
                    const color = colorMapping[ColorTokens.Primary_100];
                    let preferredMethod = [''];
                    const redirectingRoute = ROUTE.PAYMENT_START;
                    if (amount <= 2000) {
                        preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_2K;
                    }
                    else if (amount <= 100000) {
                        preferredMethod = RAZOR_PAY_PREFERRED_METHOD.LESS_THAN_100K;
                    }
                    else {
                        preferredMethod = RAZOR_PAY_PREFERRED_METHOD.DEFAULT;
                    }
                    if (Platform.OS === 'web') {
                        await handleWebPayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
                    }
                    else {
                        await handlePayment(user, amount, color, preferredMethod, collectionId, navigateToBase, timeout, network, currentOrderId, key, setDatastore, redirectingRoute);
                    }
                }
            }
            else {
                const user = await SharedPropsService.getUser();
                const test_numbers_bajaj_pg = await SharedPropsService.getFirebaseConfig()?.test_numbers_bajaj_pg;
                if (!test_numbers_bajaj_pg) {
                    return false;
                }
                const test_numbers_bajaj_pg_object = JSON.parse(test_numbers_bajaj_pg);
                const bajajPgPhoneNumbers = test_numbers_bajaj_pg_object?.numbers;
                let showBajajPg = await SharedPropsService.getFirebaseConfig().show_bajaj_pg;
                const url = Platform.OS === 'web' ? window.location.href : '';
                const params = getParameters(url);
                const platformCode = params?.platform || '';
                let enableBajajPG = false;
                if (platformCode === undefined || platformCode === null || platformCode === '') {
                    enableBajajPG = true;
                }
                else
                    enableBajajPG = false;
                // @ts-ignore
                let isPaymentModeBajaj = enableBajajPG && (showBajajPg === true || showBajajPg === "true" || bajajPgPhoneNumbers.includes(user.user.phoneNumber)) && (userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId !== "Tata");
                await network.post(`${api.collectionNew}`, {
                    baseOriginUrl: Platform.OS === 'web' ? `${config.APP_URL}` : 'https://app.voltmoney.in/mandateCallback?redirect=true&showVoltDefaultHeader=false',
                    collectionAmount: `${amount}`,
                    creditId: userCreditId,
                    paymentGatewayType: isPaymentModeBajaj ? "BAJAJ" : null,
                    redirect: Platform.OS === 'web' && !isIframe() && !isFromAndroidWebview() ? true : false,
                    paymentMode: paymentMode,
                    collectionType: collectionType !== '' && collectionType !== undefined ? collectionType : `${REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT}`
                }, { headers: await getAppHeader() })
                    .then(async (res) => {
                    if (res.status === 200) {
                        const isFromTata = userContextResponse?.data?.linkedCredits[0]?.lendingPartnerId === "Tata";
                        if (Platform.OS !== 'web') {
                            if (isFromTata) {
                                BackgroundTimer.runBackgroundTimer(async () => {
                                    console.log("REACHED IN THE METHOD");
                                    //code that will be called every 3 seconds
                                    network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                        if (response.data.collectionStatus !== 'REQUESTED') {
                                            //after this call all code on background stop run.
                                            console.log("REACHED IN THE CALLBACK");
                                            instrumentTrack("CHROME_TAB_CLOSED", { collectionStatus: response.data.collectionStatus });
                                            InAppBrowser.close();
                                            removeWidgets(ROUTE.PAYMENT_START, [
                                                { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                                { id: "keyboardSpace", type: WIDGET.SPACE },
                                                { id: "keyboardSpace2", type: WIDGET.SPACE },
                                                { id: "keyboardSpace3", type: WIDGET.SPACE },
                                            ]);
                                            //to solve race conditon android and ios
                                            if (Platform.OS === 'ios' || Platform.OS === 'android') {
                                                const paymentStatus = response.data.collectionStatus;
                                                if (paymentStatus === PaymentStatuses.COLLECTION_COMPLETE || paymentStatus === PaymentStatuses.SETTLED || paymentStatus === PaymentStatuses.SUCCESS_WITH_LENDER_RECON_FAILED) {
                                                    instrumentTrack("TATA_PAYMENT_COMPLETED", { collectionStatus: response.data.collectionStatus });
                                                }
                                                else if (paymentStatus === PaymentStatuses.FAILED) {
                                                    instrumentTrack("TATA_PAYMENT_FAILED", { collectionStatus: response.data.collectionStatus });
                                                }
                                                else if (paymentStatus === PaymentStatuses.CANCELLED) {
                                                    instrumentTrack("TATA_PAYMENT_CANCELLED", { collectionStatus: response.data.collectionStatus });
                                                }
                                                else if (paymentStatus === PaymentStatuses.PENDING_SETTLEMENT) {
                                                    instrumentTrack("TATA_PAYMENT_PENDING_SETTLEMENT", { collectionStatus: response.data.collectionStatus });
                                                }
                                                else {
                                                    instrumentTrack("TATA_PAYMENT_GOES_WRONG", { collectionStatus: response.data.collectionStatus });
                                                }
                                                navigateToBase(ROUTE.PAYMENT_CALLBACK, {
                                                    collectionId: response.data.collectionId,
                                                    //stopInterval passed to solve race condition
                                                    stopInterval: BackgroundTimer.stopBackgroundTimer()
                                                });
                                            }
                                            else {
                                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                            }
                                        }
                                    });
                                }, 3000);
                                // Only Android, iOS will ignore this call
                                instrumentTrack("CHROME_TAB_OPENED");
                                if (Platform.OS === 'android') {
                                    await appendWidgets(ROUTE.PAYMENT_START, {
                                        repayLoanWebView: {
                                            iframe: false,
                                            uri: res?.data.paymentLink,
                                            doFormPost: isPaymentModeBajaj ? true : false,
                                            height: getHeight(),
                                            showPrincipalRepayment: true,
                                            billDeskCancelAction: {
                                                type: ACTION.RESET_PAGE,
                                                routeId: ROUTE.PAYMENT_START
                                            },
                                            mfHeight: getHeight() - 150,
                                            errorTataPaymentAction: {
                                                type: ACTION.ERROR_INSTRUMENT,
                                                routeId: ROUTE.PAYMENT_START,
                                                payload: { instrumentTrack }
                                            }
                                        },
                                        keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                        keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                        keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                                    }, [
                                        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                        { id: "keyboardSpace", type: WIDGET.SPACE },
                                        { id: "keyboardSpace2", type: WIDGET.SPACE },
                                        { id: "keyboardSpace3", type: WIDGET.SPACE },
                                    ], "customHeader");
                                    removeWidgets(ROUTE.PAYMENT_START, [
                                        {
                                            id: "totalAmountShowStack",
                                            type: WIDGET.CARD,
                                            padding: {
                                                horizontal: 0,
                                                all: 0,
                                            },
                                            position: POSITION.ABSOLUTE_TOP,
                                        },
                                        {
                                            id: "titleStack",
                                            type: WIDGET.STACK,
                                        },
                                        {
                                            id: "spaceXXXL",
                                            type: WIDGET.SPACE
                                        },
                                        {
                                            id: "fullAmountStackWithSpace",
                                            type: WIDGET.STACK
                                        },
                                        {
                                            id: "spaceXXXL",
                                            type: WIDGET.SPACE
                                        },
                                        {
                                            id: "divider",
                                            type: WIDGET.DIVIDER
                                        },
                                        {
                                            id: "partialAmountFullStack",
                                            type: WIDGET.STACK
                                        },
                                        {
                                            id: "proceedButtonStack",
                                            type: WIDGET.STACK,
                                            position: POSITION.ABSOLUTE_BOTTOM
                                        },
                                        {
                                            id: "spaceLG",
                                            type: WIDGET.SPACE
                                        },
                                        { id: "enterAmountFullStack", type: WIDGET.STACK },
                                        { id: "amountMessage", type: WIDGET.TEXT }
                                    ]);
                                    await setDatastore(ROUTE.PAYMENT_START, "customHeader", {
                                        hideNeedHelp: true
                                    });
                                }
                                else
                                    openLink(res?.data.paymentLink, setDatastore);
                            }
                            else {
                                appendWidgets(ROUTE.PAYMENT_START, {
                                    repayLoanWebView: {
                                        iframe: false,
                                        uri: res.data.paymentLink,
                                        doFormPost: isPaymentModeBajaj ? true : false,
                                        mfHeight: getHeight() - 150,
                                        billDeskCancelAction: {
                                            type: ACTION.RESET_PAGE,
                                            routeId: ROUTE.PAYMENT_START
                                        }
                                    },
                                    keyboardSpace: { size: SizeTypeTokens.XXXXXXL },
                                    keyboardSpace2: { size: SizeTypeTokens.XXXXXXL },
                                    keyboardSpace3: { size: SizeTypeTokens.XXXXXXL },
                                }, [
                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                ], "customHeader");
                                removeWidgets(ROUTE.PAYMENT_START, [
                                    {
                                        id: "totalAmountShowStack",
                                        type: WIDGET.CARD,
                                        padding: {
                                            horizontal: 0,
                                            all: 0,
                                        },
                                        position: POSITION.ABSOLUTE_TOP,
                                    },
                                    {
                                        id: "titleStack",
                                        type: WIDGET.STACK,
                                    },
                                    {
                                        id: "spaceXXXL",
                                        type: WIDGET.SPACE
                                    },
                                    {
                                        id: "fullAmountStackWithSpace",
                                        type: WIDGET.STACK
                                    },
                                    {
                                        id: "spaceXXXL",
                                        type: WIDGET.SPACE
                                    },
                                    {
                                        id: "divider",
                                        type: WIDGET.DIVIDER
                                    },
                                    {
                                        id: "partialAmountFullStack",
                                        type: WIDGET.STACK
                                    },
                                    {
                                        id: "proceedButtonStack",
                                        type: WIDGET.STACK,
                                        position: POSITION.ABSOLUTE_BOTTOM
                                    },
                                    {
                                        id: "spaceLG",
                                        type: WIDGET.SPACE
                                    },
                                    { id: "enterAmountFullStack", type: WIDGET.STACK },
                                    { id: "amountMessage", type: WIDGET.TEXT }
                                ]);
                            }
                            setDatastore(action.routeId, "header", {
                                title: (isFromTata)
                                    ? (tataFlag
                                        ? "Paying to Tata Capital Limited"
                                        : "Paying to Tata Capital Financial Services Ltd.")
                                    : "Paying to Bajaj Finance"
                            });
                            const runPollar = async () => {
                                network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }).then((response) => {
                                    console.warn("COLLECTION STATUS IS", response.data.collectionStatus);
                                    if (response.data.collectionStatus !== 'REQUESTED') {
                                        clearInterval(pollarTimer);
                                        if (result) {
                                            result?.close();
                                        }
                                        removeWidgets(ROUTE.PAYMENT_START, [
                                            { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                            { id: "keyboardSpace", type: WIDGET.SPACE },
                                            { id: "keyboardSpace2", type: WIDGET.SPACE },
                                            { id: "keyboardSpace3", type: WIDGET.SPACE },
                                        ]);
                                        navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                    }
                                });
                            };
                            pollarTimer = setInterval(() => {
                                runPollar();
                            }, APP_CONFIG.POLLING_INTERVAL);
                        }
                        else {
                            if ((isIframe() || isFromAndroidWebview()) && !isPaymentModeBajaj) {
                                showPopup({
                                    isAutoTriggerCta: true,
                                    type: 'DEFAULT',
                                    iconName: IconTokens.Redirecting,
                                    title: 'Waiting for response',
                                    subTitle: 'Please wait while we process your request',
                                    ctaAction: {
                                        type: ACTION.BLANK_ACTION,
                                        routeId: ROUTE.LOAN_AGREEMENT,
                                        payload: {},
                                    },
                                    primary: false,
                                });
                                const url = res.data.paymentLink;
                                // Popup window size
                                const width = isFromTata ? 1002 : 504;
                                const height = 704;
                                // Calculate the position to center the popup on the screen
                                const left = (window.innerWidth - width) / 2;
                                const top = (window.innerHeight - height) / 2;
                                //openNewTab(url, OpenNewTabTargetType.popup, {
                                //     target: POPUP_TARGET_NAME.AGREEMENT,
                                //     width: APP_CONFIG.POP_UP_SIZE.WIDTH,
                                //     height: APP_CONFIG.POP_UP_SIZE.HEIGHT,
                                // })
                                // Open the popup window
                                if (isFromAndroidWebview()) {
                                    popupWindow = window.open(url, "_blank");
                                }
                                else {
                                    popupWindow = window.open(url, "_blank", "width=" + width + ", height=" + height + ", top=" + top + ", left=" + left);
                                }
                            }
                            else {
                                const buildType = getBuildType();
                                console.warn("IS BAJAJ MODE", isPaymentModeBajaj);
                                // @ts-ignore
                                if (lenderAccountId.toLowerCase() === "bajaj" && isPaymentModeBajaj) {
                                    if (isIframe()) {
                                        const form = document.createElement('form');
                                        form.method = 'POST';
                                        form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                            : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment';
                                        form.target = 'paymentPopup'; // Add target for the popup window
                                        // Create an input element
                                        const input = document.createElement('input');
                                        input.type = 'hidden';
                                        input.name = 'msg';
                                        input.value = res.data.paymentLink;
                                        popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                        // Append input to form
                                        form.appendChild(input);
                                        document.body.appendChild(form);
                                        form.submit();
                                    }
                                    else {
                                        const form = document.createElement('form');
                                        form.method = 'POST';
                                        form.action = buildType === BUILD_TYPE.BORROWER_PRODUCTION ? ' https://payment.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'
                                            : 'https://uatpayments.bajajfinserv.in/Paymentgateway/Payments/Direct_Loan_Payment'; // form.target = 'paymentPopup'; // Add target for the popup window
                                        // Create an input element
                                        const input = document.createElement('input');
                                        input.type = 'hidden';
                                        input.name = 'msg';
                                        input.value = res.data.paymentLink;
                                        //  popupWindow = window.open('', 'paymentPopup', 'width=600,height=600');
                                        // Append input to form
                                        form.appendChild(input);
                                        document.body.appendChild(form);
                                        form.submit();
                                    }
                                    // Open a new popup window with the specified size
                                }
                                else {
                                    window.open(res.data.paymentLink, "_self");
                                }
                                if (lenderAccountId == "Nuvama" && paymentMode === 'UPI') {
                                    navigate(ROUTE.UPI_IN_PROGRESS);
                                }
                            }
                            if (isIframe() || isFromAndroidWebview()) {
                                const runPollar = async () => {
                                    network.get(`${api.userPaymentData}${res.data.collectionId}`, { headers: await getAppHeader(), routeName: "PAYMENT_START" }, async () => {
                                        return;
                                    }, {
                                        disableDefault: true
                                    }).then((response) => {
                                        if (popupWindow?.closed) {
                                            goBack();
                                            clearInterval(timer);
                                        }
                                        else {
                                            if (response.data.collectionStatus === 'COLLECTION_COMPLETE' || response.data.collectionStatus === 'CANCELLED' || response.data.collectionStatus === 'FAILED') {
                                                removeWidgets(ROUTE.PAYMENT_START, [
                                                    { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
                                                    { id: "keyboardSpace", type: WIDGET.SPACE },
                                                    { id: "keyboardSpace2", type: WIDGET.SPACE },
                                                    { id: "keyboardSpace3", type: WIDGET.SPACE },
                                                ]);
                                                clearInterval(timer);
                                                if (popupWindow) {
                                                    popupWindow.close(); // Close the popup window if it exists
                                                }
                                                navigate(ROUTE.PAYMENT_CALLBACK, { collectionId: response.data.collectionId });
                                            }
                                        }
                                    });
                                };
                                timer = setInterval(() => {
                                    runPollar();
                                }, APP_CONFIG.POLLING_INTERVAL);
                            }
                        }
                    }
                    else {
                        setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                            loading: false
                        });
                    }
                });
                if (Platform.OS !== "ios") {
                    isIframeRemoved = true;
                }
            }
        }
    }
};
export const errorInstrument = async (action, _datastore, { instrumentTrack, navigate }) => {
    const type = action.payload.type;
    instrumentTrack(type);
};
export const isIframe = () => {
    try {
        return window.self !== window.top;
    }
    catch (e) {
        return true;
    }
};
export const editAmount = async (action, _datastore, { setDatastore, appendWidgets, network }) => {
    amount = parseFloat(action.payload.value);
    let amountToPay = amount;
    const userContextResponse = await SharedPropsService.getUser();
    const initialAmount = parseFloat(userContextResponse.linkedCredits[0].principalOutStandingAmount);
    if (amount.toString().length > 0 && amount !== 0 && !isNaN(amount)) {
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeFilled
        });
        if (amount > initialAmount) {
            await setDatastore(ROUTE.PAYMENT_START, "input", {
                state: InputStateToken.ERROR,
                caption: { error: `Maximum repayment amount is ₹${addCommasToNumber(initialAmount)}` }
            });
            await setDatastore(action.routeId, "proceedButton", {
                type: ButtonTypeTokens.LargeOutline
            });
        }
        else {
            await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
                type: ButtonTypeTokens.LargeFilled,
                justifyContent: StackJustifyContent.center
            });
            await setDatastore(ROUTE.PAYMENT_START, "input", {
                state: InputStateToken.DEFAULT,
                caption: { error: "" }
            });
        }
        await appendWidgets(ROUTE.PAYMENT_START, {
            amountText: {
                label: amount <= initialAmount ? `Paying ₹${addCommasToNumber(amountToPay)}` : "",
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                color: ColorTokens.Grey_Charcoal,
            },
            spaceSM: {
                size: SizeTypeTokens.SM
            },
        }, [{
                id: "amountText", type: WIDGET.TEXT
            }, { id: "spaceSM", type: WIDGET.SPACE }], "amountPreview");
    }
    else {
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeOutline
        });
        await setDatastore(action.routeId, "amountText", {
            label: ``,
            color: ColorTokens.White
        });
        await setDatastore(ROUTE.PAYMENT_START, "amountPreviewText", {
            color: ColorTokens.White,
            label: '',
        });
    }
};
export const onPageLoad = async (action, _datastore, { network, setDatastore, removeWidgets }) => {
    // const userContextResponse = await network.post(api.userContext, {}, {headers: await getAppHeader()});
    // await SharedPropsService.setUser(userContextResponse.data)
    // const userData = await SharedPropsService.getUser()
    const userData = await getUserContext(network);
    const initialAmount = userData.linkedCredits[0].principalOutStandingAmount;
    amount = parseFloat(initialAmount);
    if ((action.payload.value !== "fullPay" || action.payload.value !== "partialPay") && !fromRetryPayment) {
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeOutline
        });
    }
    console.log("REPAYMENT LENDER ID", userData?.linkedCredits[0]?.lendingPartnerId?.toLowerCase());
    if (userData?.linkedCredits[0]?.lendingPartnerId?.toLowerCase() === LENDER_ID.MIRAE.toLowerCase()) {
        importBillDeskSdk();
    }
};
export const unCheckPartialAmount = async (action, _datastore, { instrumentTrack, setDatastore, network, removeWidgets, appendWidgets }) => {
    instrumentTrack("REPAYMENT_AMOUNT_SELECTED_BUTTON_CLICKED", { "repayment_type": action.payload.value });
    const userContextResponse = await SharedPropsService.getUser();
    const principalLoanAmount = userContextResponse.linkedCredits[0].principalOutStandingAmount;
    if (action.payload.value === "fullPay") {
        preFilledAmount = '';
        amount = parseFloat(principalLoanAmount);
        await setDatastore(action.routeId, "fullAmountRadio", {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, "partialAmountRadio", {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeFilled
        });
        await setDatastore(action.routeId, "fullAmountText", {
            fontWeight: '600'
        });
        await setDatastore(action.routeId, "partialAmountText", {
            fontWeight: '400'
        });
        await setDatastore(ROUTE.PAYMENT_START, "amountPreviewText", {
            color: ColorTokens.Grey_Charcoal,
            label: `Paying ₹${addCommasToNumber(amount)}`,
        });
        removeWidgets(ROUTE.PAYMENT_START, [
            { id: "enterAmountFullStack", type: WIDGET.STACK },
            { id: "amountMessage", type: WIDGET.TEXT }
        ]);
        await appendWidgets(ROUTE.PAYMENT_START, {
            amountText: {
                label: `Paying ₹${addCommasToNumber(amount)}`,
                fontSize: FontSizeTokens.SM,
                fontWeight: '400',
                lineHeight: 24,
                color: ColorTokens.Grey_Charcoal,
            },
            spaceSM: {
                size: SizeTypeTokens.SM
            },
        }, [{
                id: "amountText", type: WIDGET.TEXT
            }, { id: "spaceSM", type: WIDGET.SPACE }], "amountPreview");
    }
    else {
        await setDatastore(action.routeId, "partialAmountText", {
            fontWeight: '600'
        });
        await setDatastore(action.routeId, "fullAmountText", {
            fontWeight: '400'
        });
        await setDatastore(action.routeId, "partialAmountRadio", {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, "fullAmountRadio", {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeOutline
        });
        appendWidgets(ROUTE.PAYMENT_START, {
            enterAmountFullStack: {
                type: StackType.column,
                width: StackWidth.FULL,
                padding: {
                    ...!isFromTDLPlatform() && { left: SizeTypeTokens.XXXXXL },
                    right: SizeTypeTokens.XXXXXXL
                },
                widgetItems: [
                    { id: "enterAmountInputStack", type: WIDGET.STACK },
                    { id: "spaceLG", type: WIDGET.SPACE },
                ]
            },
            enterAmountInputStack: {
                type: StackType.row,
                padding: {
                    top: SizeTypeTokens.XXL,
                    ...!isFromTDLPlatform() && { right: SizeTypeTokens.XXXXXXL }
                },
                width: StackWidth.FULL,
                widgetItems: [
                    { id: "input", type: WIDGET.INPUT },
                ]
            },
            spaceLG: {
                size: SizeTypeTokens.LG
            },
            input: {
                id: 'tf_flexiRepay_enterAmount',
                nonZeroStartingNumberPattern: true,
                type: InputTypeToken.DEFAULT,
                state: InputStateToken.DEFAULT,
                width: TextInputTypeToken.FULL,
                alignErrorInBottom: true,
                onlyNumeric: true,
                maxPayAmount: principalLoanAmount,
                placeholder: "",
                title: "Enter amount",
                keyboardType: KeyboardTypeToken.numberPad,
                action: {
                    type: ACTION.EDIT_AMOUNT,
                    routeId: ROUTE.PAYMENT_START,
                    payload: { value: "" },
                },
            },
        }, [
            { id: "enterAmountFullStack", type: WIDGET.STACK },
        ], "partialAmountFullStack");
        await setDatastore(action.routeId, "amountText", {
            label: ``,
            color: ColorTokens.White
        });
        await setDatastore(ROUTE.PAYMENT_START, "amountPreviewText", {
            color: ColorTokens.White,
            label: '',
        });
    }
};
export const goBack = async (action, _datastore, { network, navigateWithClear, goBack, removeWidgets, appendWidgets, setDatastore }) => {
    const userContextResponse = await SharedPropsService.getUser();
    const lenderId = userContextResponse?.linkedCredits[0]?.lendingPartnerId;
    const isFromTata = userContextResponse?.linkedCredits[0]?.lendingPartnerId === "Tata";
    if (Platform.OS === 'android' && isFromTata) {
        await goBack();
    }
    if (isIframeRemoved) {
        const principalLoanAmount = userContextResponse.linkedCredits[0].principalOutStandingAmount;
        await removeWidgets(ROUTE.PAYMENT_START, [{ id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
            { id: "keyboardSpace", type: WIDGET.SPACE },
            { id: "keyboardSpace2", type: WIDGET.SPACE },
            { id: "keyboardSpace3", type: WIDGET.SPACE },
        ]);
        const lenderId = userContextResponse?.linkedCredits[0]?.lendingPartnerId;
        if (lenderId !== "Nuvama") {
            appendWidgets(ROUTE.PAYMENT_START, {
                titleText: {
                    label: 'Select amount for repayment',
                    fontSize: FontSizeTokens.MD,
                    fontWeight: "600",
                    lineHeight: 24,
                    color: ColorTokens.Grey_Night,
                    fontFamily: FontFamilyTokens.Poppins
                },
                spaceXXL: {
                    size: SizeTypeTokens.XXL
                },
                spaceXXXL: {
                    size: SizeTypeTokens.XXXL,
                },
                spaceXXXXL: {
                    size: SizeTypeTokens.XXXXL,
                },
                titleStack: {
                    type: StackType.column,
                    width: StackWidth.FULL,
                    widgetItems: [
                        {
                            id: "titleText", type: WIDGET.TEXT,
                            padding: {
                                right: 16
                            }
                        },
                    ],
                },
                fullAmountStackWithSpace: {
                    type: StackType.column,
                    width: StackWidth.FULL,
                    widgetItems: [
                        { id: "selectFullAmountStack", type: WIDGET.STACK },
                        {
                            id: 'spaceXL',
                            type: WIDGET.SPACE,
                        },
                    ]
                },
                selectFullAmountStack: {
                    type: StackType.row,
                    width: StackWidth.FULL,
                    widgetItems: [
                        { id: "spaceSM", type: WIDGET.SPACE },
                        { id: "fullAmountRadio", type: WIDGET.ICON },
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "fullAmountStack", type: WIDGET.STACK },
                    ],
                    action: {
                        type: ACTION.CHECKBOX_HANDLE,
                        payload: {
                            value: "fullPay",
                        },
                        routeId: ROUTE.PAYMENT_START,
                    },
                },
                fullAmountRadio: {
                    name: IconTokens.RadioCircleNotFilled,
                    size: IconSizeTokens.XXL,
                },
                partialAmountRadio: {
                    name: IconTokens.RadioCircleNotFilled,
                    size: IconSizeTokens.XXL,
                },
                fullAmountStack: {
                    type: StackType.column,
                    width: StackWidth.CONTENT,
                    height: StackHeight.CONTENT,
                    widgetItems: [
                        { id: "fullAmountText", type: WIDGET.TEXT },
                        { id: "spaceSM", type: WIDGET.SPACE },
                    ]
                },
                partialAmountFullStack: {
                    type: StackType.column,
                    width: StackWidth.FULL,
                    widgetItems: [
                        {
                            id: "spaceXL",
                            type: WIDGET.SPACE
                        },
                        {
                            id: "selectPartialAmountStack", type: WIDGET.STACK
                        }
                    ]
                },
                selectPartialAmountStack: {
                    type: StackType.row,
                    width: StackWidth.FULL,
                    widgetItems: [
                        { id: "spaceSM", type: WIDGET.SPACE },
                        { id: "partialAmountRadio", type: WIDGET.ICON },
                        { id: "spaceXXL", type: WIDGET.SPACE },
                        { id: "partialAmountText", type: WIDGET.TEXT }
                    ],
                    action: {
                        type: ACTION.CHECKBOX_HANDLE,
                        payload: {
                            value: "partialPay",
                        },
                        routeId: ROUTE.PAYMENT_START,
                    },
                },
                divider: {
                    size: DividerSizeTokens.MD,
                    margin: {
                        all: SizeTypeTokens.XL
                    },
                    color: ColorTokens.Grey_Milk
                },
                spaceSM: {
                    size: SizeTypeTokens.SM
                },
                spaceLG: {
                    size: SizeTypeTokens.LG
                },
                spaceXL: {
                    size: SizeTypeTokens.XL
                },
                enterAmountFullStack: {
                    type: StackType.column,
                    width: StackWidth.FULL,
                    padding: {
                        left: SizeTypeTokens.XXXXXL,
                        right: SizeTypeTokens.XXXXXXL
                    },
                    widgetItems: [
                        { id: "enterAmountInputStack", type: WIDGET.STACK },
                        { id: "spaceLG", type: WIDGET.SPACE },
                    ]
                },
                enterAmountInputStack: {
                    type: StackType.row,
                    padding: {
                        top: SizeTypeTokens.XXL,
                        right: SizeTypeTokens.XXXXXXL
                    },
                    width: StackWidth.FULL,
                    widgetItems: [
                        { id: "input", type: WIDGET.INPUT },
                    ]
                },
                input: {
                    type: InputTypeToken.DEFAULT,
                    state: InputStateToken.DEFAULT,
                    width: TextInputTypeToken.FULL,
                    placeholder: "",
                    alignErrorInBottom: true,
                    title: "Enter amount",
                    maxPayAmount: principalLoanAmount,
                    onlyNumeric: true,
                    keyboardType: KeyboardTypeToken.numberPad,
                    action: {
                        type: ACTION.EDIT_AMOUNT,
                        routeId: ROUTE.PAYMENT_START,
                        payload: { value: "" },
                    },
                },
                fullAmountText: {
                    label: 'Pay full amount',
                    fontSize: FontSizeTokens.MD,
                    fontWeight: '400',
                    lineHeight: 24,
                    fontFamily: FontFamilyTokens.Inter
                },
                partialAmountText: {
                    label: 'Pay partial amount',
                    fontSize: FontSizeTokens.MD,
                    fontWeight: '400',
                    lineHeight: 24,
                    fontFamily: FontFamilyTokens.Inter
                },
                fullAmountValue: {
                    label: `₹${addCommasToNumber(Number(principalLoanAmount))}`,
                    fontSize: FontSizeTokens.SM,
                    fontWeight: '400',
                    lineHeight: 24,
                    color: ColorTokens.Grey_Charcoal,
                    fontFamily: FontFamilyTokens.Inter
                },
                proceedButtonStack: {
                    width: StackWidth.FULL,
                    type: StackType.column,
                    justifyContent: StackJustifyContent.center,
                    alignSelf: StackSelfContent.center,
                    alignContent: StackAlignContent.center,
                    alignItems: StackAlignItems.center,
                    widgetItems: [
                        { id: "amountPreviewText", type: WIDGET.TEXT },
                        { id: "spaceSM", type: WIDGET.SPACE },
                        { id: "proceedButton", type: WIDGET.BUTTON },
                        {
                            id: "spaceLG",
                            type: WIDGET.SPACE
                        },
                    ]
                },
                amountPreviewText: {
                    fontSize: FontSizeTokens.SM,
                    fontWeight: '400',
                    lineHeight: 24,
                    color: ColorTokens.White,
                },
                spaceXXXXXL: {
                    size: SizeTypeTokens.XXXXXL
                },
                proceedButton: {
                    label: "Select payment method",
                    fontWeight: "700",
                    fontFamily: FontFamilyTokens.Inter,
                    fontSize: FontSizeTokens.SM,
                    type: ButtonTypeTokens.LargeOutline,
                    width: ButtonWidthTypeToken.FULL,
                    justifyContent: StackJustifyContent.center,
                    alignSelf: StackSelfContent.center,
                    action: {
                        payload: {},
                        type: ACTION.PAYMENT_DASHBOARD,
                        routeId: ROUTE.PAYMENT_START
                    }
                },
                totalAmountShowStack: {
                    bgColor: ColorTokens.Grey_Milk,
                    body: { widgetItems: [{ id: "totalAmountStack", type: WIDGET.STACK }] },
                    alignItems: StackAlignItems.center,
                    padding: {
                        bottom: SizeTypeTokens.NONE
                    },
                    justifyContent: StackJustifyContent.spaceBetween,
                },
                totalAmountStack: {
                    padding: { top: SizeTypeTokens.LG, bottom: SizeTypeTokens.LG },
                    width: StackWidth.FULL,
                    type: StackType.column,
                    alignItems: StackAlignItems.flexStart,
                    widgetItems: [
                        { id: "totalAmountTitle", type: WIDGET.TEXT },
                        { id: "spaceLG", type: WIDGET.SPACE },
                        { id: "totalAmountValue", type: WIDGET.TEXT },
                    ],
                },
                totalAmountTitle: {
                    label: "Outstanding amount",
                    fontFamily: FontFamilyTokens.Inter,
                    fontWeight: "400",
                    fontSize: FontSizeTokens.SM,
                    color: ColorTokens.Grey_Charcoal,
                },
                totalAmountValue: {
                    label: `₹${addCommasToNumber(Number(principalLoanAmount))}`,
                    fontWeight: "600",
                    fontSize: FontSizeTokens.MD,
                    color: ColorTokens.Grey_Night,
                },
            }, [
                {
                    id: "totalAmountShowStack",
                    type: WIDGET.CARD,
                    padding: {
                        horizontal: 0,
                        all: 0,
                    },
                    position: POSITION.ABSOLUTE_TOP,
                },
                {
                    id: 'spaceXL',
                    type: WIDGET.SPACE,
                },
                {
                    id: "titleStack",
                    type: WIDGET.STACK,
                },
                {
                    id: "spaceXXXL",
                    type: WIDGET.SPACE
                },
                {
                    id: "fullAmountStackWithSpace",
                    type: WIDGET.STACK
                },
                {
                    id: "divider",
                    type: WIDGET.DIVIDER
                },
                {
                    id: "partialAmountFullStack",
                    type: WIDGET.STACK
                },
                {
                    id: "proceedButtonStack",
                    type: WIDGET.STACK,
                    position: POSITION.ABSOLUTE_BOTTOM
                },
            ]);
            await setDatastore(action.routeId, "customHeader", {
                title: "Flexi pay"
            });
        }
        isIframeRemoved = false;
    }
    else {
        const isFromDashboard = action?.payload?.isFromDashboard;
        const isFromTransactions = action?.payload?.isFromTransactions;
        if (isFromTransactions) {
            navigateWithClear(ROUTE.TRANSACTIONS);
        }
        else if (lenderId !== 'Bajaj' || isFromDashboard || preFilledAmount) {
            navigateWithClear(ROUTE.DASHBOARD);
        }
        else {
            navigateWithClear(ROUTE.REPAYMENT);
        }
    }
};
export const resetPage = async (action, _datastore, { network, setDatastore, navigateWithClear, removeWidgets, appendWidgets }) => {
    await removeWidgets(ROUTE.PAYMENT_START, [
        { id: "repayLoanWebView", type: WIDGET.WEB_VIEW },
        { id: "keyboardSpace", type: WIDGET.SPACE },
        { id: "keyboardSpace2", type: WIDGET.SPACE },
        { id: "keyboardSpace3", type: WIDGET.SPACE },
    ]);
    clearInterval(pollarTimer);
    await navigateWithClear(ROUTE.PAYMENT_START);
};
export const needHelp = async (action, _datastore, { navigate, setDatastore, removeWidgets }) => {
    const isFromDashboard = action?.payload?.isFromDashboard;
    await navigate(ROUTE.CONTACT_US_CARD, {
        amountToPay: preFilledAmount,
        isFromDashboard: isFromDashboard
    });
};
export const prefillPartialAmountAction = async (action, _datastore, { appendWidgets, setDatastore, removeWidgets }) => {
    fromRetryPayment = true;
    preFilledAmount = action?.payload?.amount;
    amount = preFilledAmount;
    collectionType = action?.payload?.collectionType;
    const principalLoanAmount = action?.payload?.principalLoanAmount;
    await setDatastore(action.routeId, "partialAmountText", {
        fontWeight: '600'
    });
    await setDatastore(action.routeId, "fullAmountText", {
        fontWeight: '400'
    });
    await setDatastore(action.routeId, "partialAmountRadio", {
        name: IconTokens.RadioCircleFilled,
    });
    await setDatastore(action.routeId, "fullAmountRadio", {
        name: IconTokens.RadioCircleNotFilled,
    });
    await setDatastore(ROUTE.PAYMENT_START, "input", {
        state: InputStateToken.DEFAULT,
        caption: { error: "" }
    });
    if (preFilledAmount > principalLoanAmount || preFilledAmount === '') {
        await setDatastore(ROUTE.PAYMENT_START, "proceedButton", {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
    else {
        await setDatastore(action.routeId, "proceedButton", {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    appendWidgets(ROUTE.PAYMENT_START, {
        enterAmountFullStack: {
            type: StackType.column,
            width: StackWidth.FULL,
            padding: {
                left: SizeTypeTokens.XXXXXL,
                right: SizeTypeTokens.XXXXXXL
            },
            widgetItems: [
                { id: "enterAmountInputStack", type: WIDGET.STACK },
                { id: "spaceLG", type: WIDGET.SPACE },
            ]
        },
        enterAmountInputStack: {
            type: StackType.row,
            padding: {
                top: SizeTypeTokens.XXL,
                right: SizeTypeTokens.XXXXXXL
            },
            width: StackWidth.FULL,
            widgetItems: [
                { id: "input", type: WIDGET.INPUT },
            ]
        },
        spaceLG: {
            size: SizeTypeTokens.LG
        },
        input: {
            id: 'tf_flexiRepay_enterAmount',
            nonZeroStartingNumberPattern: true,
            type: InputTypeToken.DEFAULT,
            state: preFilledAmount > principalLoanAmount ? InputStateToken.ERROR : InputStateToken.DEFAULT,
            width: TextInputTypeToken.FULL,
            alignErrorInBottom: true,
            onlyNumeric: true,
            maxPayAmount: principalLoanAmount,
            placeholder: "",
            title: "Enter amount",
            caption: { error: `Maximum repayment amount is ₹${addCommasToNumber(principalLoanAmount)}` },
            value: `${preFilledAmount}`,
            keyboardType: KeyboardTypeToken.numberPad,
            showErrorOnFocus: true,
            action: {
                type: ACTION.EDIT_AMOUNT,
                routeId: ROUTE.PAYMENT_START,
                payload: { value: '' },
            },
            charLimit: principalLoanAmount === null
                ? 0
                : principalLoanAmount.length,
        },
    }, [
        { id: "enterAmountFullStack", type: WIDGET.STACK },
    ], "partialAmountFullStack");
    await setDatastore(action.routeId, "amountText", {
        label: ``,
        color: ColorTokens.White
    });
    await setDatastore(ROUTE.PAYMENT_START, "amountPreviewText", {
        color: ColorTokens.White,
        label: '',
    });
};
export const navigateToSummaryScreen = async (action, _datastore, { navigate }) => {
    const selectedAmount = action?.payload?.inputValue;
    const userPaymentData = await SharedPropsService.getPaymentData();
    const isHavingShortfall = userPaymentData?.isHavingShortfall;
    const collectionType = isHavingShortfall ? REPAYMENT_COLLECTION_TYPE.SHORTFALL_REPAYMENT : REPAYMENT_COLLECTION_TYPE.PRINCIPAL_REPAYMENT;
    await navigate(ROUTE.CONFIRM_AND_PAYMENT, { selectedAmount, collectionType });
};
export const navigateToDashboardScreen = async (action, _datastore, { navigateWithClear }) => {
    await await navigateWithClear(ROUTE.DASHBOARD);
};
export const trackSelectedPaymentType = async (action, _datastore, { instrumentTrack, navigate }) => {
    const type = action.payload.type;
    instrumentTrack("REPAYMENT_AMOUNT_SELECTED_BUTTON_CLICKED", { "repayment_type": type });
};
